export interface ApiFormFields {
  [module: string]: {
    field: string;
    type: string;
  }[];
}

export interface Pagination {
	pageNo: number;
	limit: number;
	totalCount: number;
}

interface IState {
  rows: any[];
  workflowTemplate: any[];
  workflow: any[];
  isLoading: boolean;
  isError: boolean;
  count: number;
  error: string;
  formData: any[];
  fields: ApiFormFields | null;
  isSuccess: boolean;
  workflowAutomationId: {};
  paginationModel: Pagination;
}

export const state: IState = {
  rows: [],
  workflowTemplate: [],
  workflow: [],
  isLoading: false,
  isError: false,
  count: 0,
  error: "",
  formData: [],
  fields: null,
  isSuccess: false,
  workflowAutomationId: {},
  paginationModel:{
    pageNo:1,
    limit:10,
    totalCount: 0
  }
};
export default state;
